import React, { useState, useRef } from 'react';
import { Tabs, Tooltip } from 'antd';
import { Button, PopAlert } from 'appkit-react';
import { connect, useSelector } from 'react-redux';
import action from '@flux/action';
import { API } from '@service';
import { spliceString } from '@utils/common';

import {
  formatFun,
  addMarkToKeyName,
  deleteMarkFromKeyName,
} from './formUtils';
import TabOne from './tabOne.js';
import TabTwo from './tabTwo.js';

const { TabPane } = Tabs;

const KeyExecutives = ({
  companyNames,
  keyContactsData,
  saveKeyContactsData,
  toggleMode,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const buyerRef = useRef(null);
  const targetRef = useRef(null);
  const projectId = useSelector((state) => state.common.currentId);
  const sortNum = (arr) =>
    Array.isArray(arr) &&
    arr.map((item, idx) => {
      if (!item.linkedin) {
        item.linkedin = '';
      }
      if (!item.shouldDisplay) {
        item.shouldDisplay = false;
      }
      delete item.canEdit;
      delete item.isFromCraft;
      item.displayOrder = idx;
      return item;
    });

  return (
    <div className="tabs-box">
      <Tabs
        activeKey={activeTab}
        onChange={(num) => {
          if (num === '1') {
            setActiveTab('1');
            const data =
              (targetRef.current && targetRef.current.form.getFieldsValue()) ||
              {};
            saveKeyContactsData({
              ...keyContactsData,
              target: deleteMarkFromKeyName(data, '2'),
            });
          } else {
            setActiveTab('2');
            const data = buyerRef.current.form.getFieldsValue();
            saveKeyContactsData({
              ...keyContactsData,
              buyer: deleteMarkFromKeyName(data, '1'),
            });
          }
        }}
      >
        <TabPane
          tab={
            <Tooltip title={companyNames.buyerName}>
              {spliceString(companyNames.buyerName, 12, '...') || '-'}
            </Tooltip>
          }
          key="1"
        >
          <TabOne
            bodyContentList={addMarkToKeyName(keyContactsData.buyer, '1')}
            type={activeTab}
            cRef={buyerRef}
          />
        </TabPane>
        <TabPane
          tab={
            <Tooltip title={companyNames.targetName}>
              {spliceString(companyNames.targetName, 12, '...') || '-'}
            </Tooltip>
          }
          key="2"
        >
          <TabTwo
            bodyContentList={addMarkToKeyName(keyContactsData.target, '2')}
            type={activeTab}
            cRef={targetRef}
          />
        </TabPane>
      </Tabs>
      <div className="btn-box">
        <Button
          className="cancel"
          kind="second"
          isLoading={isLoading}
          onClick={() => {
            toggleMode();
          }}
        >
          cancel
        </Button>
        <Button
          isLoading={isLoading}
          className="save"
          onClick={async () => {
            let buyerFormData = {};
            let targetFormData = {};

            try {
              buyerFormData = await buyerRef.current.form.validateFields();
            } catch (err) {
              if (targetRef.current) {
                saveKeyContactsData({
                  ...keyContactsData,
                  buyer: deleteMarkFromKeyName(
                    buyerRef.current.form.getFieldsValue(),
                    '1',
                  ),
                  target: deleteMarkFromKeyName(
                    targetRef.current.form.getFieldsValue(),
                    '2',
                  ),
                });
              }
              return setActiveTab('1');
            }

            if (!targetRef.current) {
              targetFormData = keyContactsData.target;
            } else {
              try {
                targetFormData = await targetRef.current.form.validateFields();
              } catch (err) {
                saveKeyContactsData({
                  ...keyContactsData,
                  buyer: deleteMarkFromKeyName(buyerFormData, '1'),
                  target: deleteMarkFromKeyName(
                    targetRef.current.form.getFieldsValue(),
                    '2',
                  ),
                });
                return setActiveTab('2');
              }
            }
            buyerFormData = deleteMarkFromKeyName(buyerFormData, '1');
            targetFormData = deleteMarkFromKeyName(targetFormData, '2');

            saveKeyContactsData({
              ...keyContactsData,
              buyer: buyerFormData,
              target: targetFormData,
            });

            const submitData = {
              keyContacts: {},
            };
            //---format data start
            submitData.keyContacts.buyer = sortNum(buyerFormData.executives);
            submitData.keyContacts.target = sortNum(targetFormData.executives);
            //---format data end
            setIsLoading(true);
            const postRes = await API.postKeyContactsData(
              projectId,
              submitData,
            );
            if (postRes === null) {
              setIsLoading(false);
            }
            if (postRes && postRes.replacement) {
              setIsLoading(false);
              PopAlert({
                className: 'success-message-popover',
                oneLineDisplay: true,
                duration: 3000,
                status: 'success',
                message: 'SAVED SUCCESSFULLY',
              });
              const response = await API.getAnalysisData(
                projectId,
                'Key Contacts',
              );
              toggleMode();
              saveKeyContactsData(formatFun(response.table));
            }
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );
};
const mapStateToProps = ({ analysis }) => ({
  keyContactsData: analysis.keyContactsData,
});
const mapDispatchToProps = (dispatch) => ({
  saveKeyContactsData(data) {
    dispatch(action.saveKeyContactsData(data));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(KeyExecutives));
